import React from "react";

const Navigation = ({ active }) => {
  return (
    <div className="app__navigation">
      {["home", "about", "skills", "work", "contact"].map((item, index) => (
        <a
          key={item + index}
          href={`#${item}`}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: "#b9b692" } : {}}
        />
      ))}
    </div>
  );
};

export default Navigation;
